angular.module('vies-registry', ['core'])
    .factory('ViesRegistry', function ($resource) {
        return $resource('/crm/api/vies-registry', {}, {
            check: {
                method: 'GET',
                url: '/crm/api/vies-registry/check'
            }
        })
    })
    .service('ViesService', function (toastr, modals, ViesRegistry, $q) {
        this.check = (vatNumber, countryCode) => {
            if (vatNumber == null || vatNumber.trim() === '') {
                toastr.warning('Uzupełnij numer NIP/VAT UE')
                return $q.reject('missing-vat-number')
            }

            return ViesRegistry.check({
                vatNumber: vatNumber,
                countryCode: countryCode
            }).$promise
                .then(result => modals.open(
                    'app/vies-registry/preview-modal.html',
                    'ViesRegistryPreviewDialogController',
                    result,
                    {size: 'md'},
                    '$ctrl'
                ))
                .catch(rejection => {
                    if (rejection && rejection.status === 502) {
                        const message = rejection.data
                            && rejection.data.messages
                            && rejection.data.messages.length > 0
                            ? rejection.data.messages[0]
                            : 'Usługa VIES jest chwilowo niedostępna'
                        toastr.error(message)
                    }
                    return $q.reject(rejection)
                })
        }
    })
    .controller('ViesRegistryPreviewDialogController', function (data, $uibModalInstance) {
        this.item = data

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.apply = () => {
            if (this.item.valid) {
                $uibModalInstance.close(this.item)
            }
        }
    })
